import { IOfferState } from '../../types/reducers/offer';

export const isAreaPartsEmpty = ({ areaParts }: IOfferState) => {
  return !Array.isArray(areaParts) || areaParts.filter(Boolean).length === 0;
};
